import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickAccessCard = ({ 
  title, 
  value, 
  iconName, 
  iconColor, 
  trend = null,
  onClick 
}) => {
  return (
    <div 
      className="clinical-card p-4 cursor-pointer hover:shadow-md transition-clinical"
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={iconName} size={20} color={iconColor} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 text-xs font-medium ${
            trend?.direction === 'up' ? 'text-success' : 'text-error'
          }`}>
            <Icon 
              name={trend?.direction === 'up' ? 'TrendingUp' : 'TrendingDown'} 
              size={14} 
            />
            <span>{trend?.value}</span>
          </div>
        )}
      </div>
      <h4 className="text-2xl font-bold text-foreground mb-1 font-mono">{value}</h4>
      <p className="text-sm text-muted-foreground">{title}</p>
    </div>
  );
};

export default QuickAccessCard;